export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11057.47bff6c0.jpg";